import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Forms } from "./types.js";
addProp(_List, "forms", Forms, "forms");
//# sourceMappingURL=list.js.map